import { render, staticRenderFns } from "./AllJobDetails.vue?vue&type=template&id=bf9beeac&"
import script from "./AllJobDetails.vue?vue&type=script&lang=js&"
export * from "./AllJobDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports